import axios from 'axios'
import queryString from 'query-string'

import { ERROR_MESSAGE_DELETING_FILE, ERROR_MESSAGE_DOWNLOADING_FILE, ERROR_MESSAGE_SAVING } from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { formatFileUploadErrorMessage, formatFileUploadSuccessMessage, truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE = 'DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const DOWNLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE = 'DOWNLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES = 'RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES'
export const REMOVE_AND_DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE =
    'REMOVE_AND_DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const REMOVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE = 'REMOVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES = 'REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES'
export const SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE = 'SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE =
    'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'
export const UPLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE = 'UPLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE'

export const requestQuarterlyTaxReturnsAnnualSummaryFiles =
    (quarterlyTaxReturnsAnnualSummaryId) => (dispatch, getState) => {
        dispatch({
            type: REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES,
            data: { quarterlyTaxReturnsAnnualSummaryId },
        })

        const { quarterlyTaxReturnsAnnualSummary } = getState()
        const { id: activeQuarterlyTaxReturnsAnnualSummaryId } = quarterlyTaxReturnsAnnualSummary

        const quarterlyTaxReturnsAnnualSummaryIdToRequest =
            quarterlyTaxReturnsAnnualSummaryId || activeQuarterlyTaxReturnsAnnualSummaryId

        return axios
            .get(
                `/quarterlytaxreturnsannualsummaryfiles?quarterlyTaxReturnsAnnualSummaryId=${quarterlyTaxReturnsAnnualSummaryIdToRequest}`
            )
            .then((response) => {
                const items = response?.data || []
                dispatch(
                    receiveQuarterlyTaxReturnsAnnualSummaryFiles({ items, fetchSuccessful: true, isFetching: false })
                )
            })
            .catch((error) => {
                dispatch(receiveQuarterlyTaxReturnsAnnualSummaryFiles({ fetchSuccessful: false, isFetching: false }))

                dispatch(handleRequestError(error))
            })
    }

export const receiveQuarterlyTaxReturnsAnnualSummaryFiles = (data) => ({
    type: RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILES,
    data,
})

export const uploadQuarterlyTaxReturnsAnnualSummaryFile = (data) => (dispatch, getState) => {
    dispatch({ type: UPLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

    const { quarterlyTaxReturnsAnnualSummary } = getState()

    const { file, fileSubType, fileType, quarterlyTaxReturnsAnnualSummaryId } = data

    const params = {
        quarterlyTaxReturnsAnnualSummaryId: quarterlyTaxReturnsAnnualSummaryId || quarterlyTaxReturnsAnnualSummary.id,
        fileSubType: fileSubType || '',
        fileType: fileType || '',
    }

    const formData = new FormData()
    formData.append('file', file)

    return axios
        .post(`/quarterlytaxreturnsannualsummaryfiles?${queryString.stringify(params)}`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        })
        .then(() => {
            dispatch(receiveSuccessAlert(formatFileUploadSuccessMessage(file?.name)))

            dispatch(
                requestQuarterlyTaxReturnsAnnualSummaryFiles(
                    quarterlyTaxReturnsAnnualSummaryId || quarterlyTaxReturnsAnnualSummary.id
                )
            )
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: formatFileUploadErrorMessage(file?.name) }))
        })
}

export const removeAndDeleteQuarterlyTaxReturnsAnnualSummaryFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

        dispatch(removeQuarterlyTaxReturnsAnnualSummaryFile(data))
        dispatch(deleteQuarterlyTaxReturnsAnnualSummaryFile(data, options))
    }

export const removeQuarterlyTaxReturnsAnnualSummaryFile = (data) => ({
    type: REMOVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE,
    data,
})

export const deleteQuarterlyTaxReturnsAnnualSummaryFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

        const { id, fileName } = data

        axios
            .delete(`/quarterlytaxreturnsannualsummaryfiles/${id}`)
            .then(() => {
                dispatch(removeQuarterlyTaxReturnsAnnualSummaryFile({ id }))

                if (!hideAlert) {
                    receiveSuccessAlert(`Archivo ${fileName ? `"${truncateTextMiddle(fileName)}"` : ''} eliminado`)
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const updateAndSaveQuarterlyTaxReturnsAnnualSummaryFile = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

    dispatch(receiveQuarterlyTaxReturnsAnnualSummaryFiles({ items: [data] }))
    dispatch(saveQuarterlyTaxReturnsAnnualSummaryFile(data))
}

export const saveQuarterlyTaxReturnsAnnualSummaryFile = (data) => (dispatch) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

    const { id } = data

    axios
        .put(`/quarterlytaxreturnsannualsummaryfiles/${id}`, data)
        .then((response) => {
            const item = response?.data

            if (!item) return

            dispatch(receiveQuarterlyTaxReturnsAnnualSummaryFiles({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const downloadQuarterlyTaxReturnsAnnualSummaryFile = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_FILE, data })

    const { id } = data

    return axios
        .get(`/quarterlytaxreturnsannualsummaryfiles/${id}/downloadlink`)
        .then((response) => {
            if (!response?.data) {
                return Promise.reject()
            }

            window.location.assign(response.data)
            return Promise.resolve()
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}
